import {
  Center,
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

import YoutubeEmbed from "components/base/YoutubeEmbed";

export default function ModalVideo({ isOpen, onClose, videoId, ...props }) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="full"
      isCentered
      motionPreset="scale"
      scrollBehavior="inside"
    >
      <ModalOverlay bg="overlayBlack" {...props}>
        <ModalContent color="white" bg="transparent" m={0}>
          <ModalBody p={0} style={{ overflow: "hidden" }}>
            <Center h="100vh" w="100%" onClick={onClose}>
              <Box minW="100%">
                <YoutubeEmbed mx="auto" maxW="90vw" maxH="90vh" id={videoId} />
              </Box>
            </Center>
          </ModalBody>
          <ModalCloseButton />
        </ModalContent>
      </ModalOverlay>
    </Modal>
  );
}
